import { render, staticRenderFns } from "./PatientRecordNotesHistory.vue?vue&type=template&id=b08c20d0&scoped=true"
import script from "./PatientRecordNotesHistory.vue?vue&type=script&lang=js"
export * from "./PatientRecordNotesHistory.vue?vue&type=script&lang=js"
import style0 from "./PatientRecordNotesHistory.vue?vue&type=style&index=0&id=b08c20d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08c20d0",
  null
  
)

export default component.exports